<template>
  <div class="uikit_input">
    <input type="text" v-model="val" @input="update" @keydown.enter="submit" />
    <div class="uikit_input_submit" @click="submit">
      <uikit-icon v-if="!loading" name="send" class="send_icon" />
      <h5 class="loader" v-else>&bull;&bull;&bull;</h5>
    </div>
  </div>
</template>

<script>
import UikitIcon from "./component.uikit.icon.vue";

export default {
  name: "UikitInput",
  components: {
    UikitIcon,
  },
  props:{
    value: String,
    loading: Boolean
  },
  data() {
    return {
      val: "",
    };
  },
  methods: {
    update() {
      this.$emit("input", this.val);
    },
    submit() {
      this.$emit("submit", this.val);
    },
  },
  watch:{
    value(newVal){
      this.val = newVal
    }
  }
};
</script>

<style scoped>
.uikit_input {
  display: flex;
  max-width: 768px;
  width: 100%;
  padding: 10px;
  background: #40414f;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.uikit_input > input[type="text"] {
  background: transparent;
  border: none;
  flex: 1;
  outline: none !important;
  color: white;
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: normal;
  font-weight: 400;
}
.send_icon {
  opacity: 0.5;
  transition: all 0.25s;
}
.uikit_input_submit {
  background: transparent;
  cursor: pointer;
  padding: 2px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s;
  height: 24px;
  box-sizing: border-box;
}
.uikit_input_submit:hover {
  background: rgba(0, 0, 0, 0.4);
}
.uikit_input_submit:hover > .send_icon, .loader {
  opacity: 0.8;
}
</style>
